import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "../../../core/service/common-service/common.service";
import { interval, Subscription } from "rxjs";
import { MatMenuTrigger } from "@angular/material";
import { IndentStyle } from "typescript";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  @ViewChild("notification", { static: true }) trigger: MatMenuTrigger;

  userName: String;
  public uamAccess: String = "false";
  userRoles: string;
  navLinks: Array<any> = [];
  dropdown1:Array<any>=[];
  spinner: boolean;
  userId: string;
  notificationList: any;
  message: string[] = [];
  count: number = 0;
  //intervalId: any;
  now: Date = new Date();
  subscription: Subscription;
  intervalId: number;
  showNotifications: boolean;
  countryCode: string;
  roleId: string ;
  userInfo: any;
  constructor(
    private router: Router,
    private commonService: CommonService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {

    this.roleId = localStorage.getItem("roleId");
    this.userName = localStorage.getItem("userName");
    this.userRoles = localStorage.getItem("userRoles");
    this.uamAccess = localStorage.getItem("uamAccess");
    this.userId = localStorage.getItem("userId");
    this.countryCode = localStorage.getItem('countryCode');
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))[0];
    this.userInfo = userInfo;
    if(this.userRoles === "SME" && this.countryCode === "IND91") {
      this.navLinks.push({
        id: "lost-customer",
        routerLink: "/lost-customer",
        icon: "eicher/assets/img/calling-list.png",
        name: "Lost Customer",
      })
      this.navLinks.push({
        id: "reporting",
        routerLink: "/reporting",
        icon: "eicher/assets/img/reporting.png",
        name: "Reporting",
      });
      this.navLinks.push({
        id: "doorstep",
        routerLink: "/doorstep-calling-list",
        icon: "eicher/assets/img/calling-list.png",
        name: "Doorstep",
      });
      this.navLinks.push({
        id: "doorstep-dashboard",
        routerLink: "/doorstep-dashboard",
        icon: "eicher/assets/img/dashboard.png",
        name: "Dashboard",
      })
    }
    if (this.userRoles == "CRE" && this.countryCode != "BNG88") {
      this.navLinks = [
        {
          id: "callList",
          routerLink: "/calling",
          icon: "/eicher/assets/img/calling-list.png",
          name: "Calling List",
        },
        {
          id: "inboundCall",
          routerLink: "/inboundCall",
          icon: "/eicher/assets/img/inbound call.png",
          name: "Inbound Call",
        },

        {
          id: "prs-callList",
          routerLink: "/prs-calling",
          icon: "/eicher/assets/img/calling-list.png",
          name: "PRS Calling List",
        },
        {
          id: "prs-reporting",
          routerLink: "/prs-reporting",
          icon: "/eicher/assets/img/reporting.png",
          name: "PRS Reporting",
        }
      ];
      this.dropdown1=[
        {
          id: "soft-calling",
          routerLink: "/soft-calling",
          icon: "/eicher/assets/img/calling-list.png",
          name: "Soft Offering",
        }
      ];
    }

    if (this.userRoles == "Call Center Agent" && this.countryCode != "BNG88") {
      this.navLinks.push({
        id: "prs-callList",
        routerLink: "/prs-calling",
        icon: "/eicher/assets/img/calling-list.png",
        name: "Calling List",
      });
      this.navLinks.push({
        id: "prs-reporting",
        routerLink: "/prs-reporting",
        icon: "/eicher/assets/img/reporting.png",
        name: "Reporting",
      });
       this.navLinks.push({
         id: "workshop-reassignment",
         routerLink: "/workshop-reassignment",
         icon: "/eicher/assets/img/calling-list.png",
         name: "Workshop Reassignment",
       });
    } else if (this.userRoles == "Team Leader" || this.userRoles == "Manager") {
      this.navLinks.push({
        id: "prs-reporting",
        routerLink: "/prs-reporting",
        icon: "/eicher/assets/img/reporting.png",
        name: "Reporting",
      });
    } else if (this.userRoles == "Workshop Manager") {
      this.navLinks.push({
        id: "workshop-manager-calling",
        routerLink: "/workshop-manager-calling",
        icon: "/eicher/assets/img/calling-list.png",
        name: "Lost Customer",
      });
      this.dropdown1.push({
        id: "soft-calling",
        routerLink: "/soft-calling",
        icon: "/eicher/assets/img/calling-list.png",
        name: "Soft Offering",
      });
      this.navLinks.push({
        id: "soft-reporting",
        routerLink: "/soft-reporting",
        icon: "/eicher/assets/img/reporting.png",
        name: "Soft Offering Reporting",
      });
      this.navLinks.push({
        id: "dashboard",
        routerLink: "/dashboard",
        icon: "/eicher/assets/img/dashboard.png",
        name: "Dashboard",
      });
    } else if (this.countryCode != "BNG88") {
      if(this.countryCode!="IND91" ||  (this.userRoles != "SME" && this.userRoles != "DSPM")){
        this.navLinks.push({
          id: "reporting",
          routerLink: "/reporting",
          icon: "/eicher/assets/img/reporting.png",
          name: "Reporting",
        });
        this.navLinks.push({
          id: "soft-reporting",
          routerLink: "/soft-reporting",
          icon: "/eicher/assets/img/reporting.png",
          name: "Soft Offering Reporting",
        });
        this.navLinks.push({
          id: "dashboard",
          routerLink: "/dashboard",
          icon: "/eicher/assets/img/dashboard.png",
          name: "Dashboard",
        });
      }
    }

    if (this.countryCode != "BNG88" && this.userRoles != "CRE" && this.userRoles != "Call Center Agent" && this.userRoles != "SME" && this.userRoles != "DSPM") {
      this.navLinks.push({
        id: "market-reporting",
        routerLink: "/market-reporting",
        icon: "/eicher/assets/img/reporting.png",
        name: "Market Share Reporting",
      });
    }

    if ((this.userRoles == "CRE" || this.userRoles == "Vecv SRM User" || this.userRoles == "Pan India") && this.countryCode != "BNG88") {
      this.navLinks.push({
        id: "cdm-calling",
        routerLink: "/cdm-calling",
        icon: "/eicher/assets/img/calling-list.png",
        name: "Service Request",
      });
    }

    if ((this.userRoles == "Vecv SRM User") && this.countryCode == "BNG88") {
      this.navLinks.push({
        id: "cdm-calling",
        routerLink: "/cdm-calling",
        icon: "/eicher/assets/img/calling-list.png",
        name: "Service Request",
      });
    }

    if(this.userRoles == "CRE" && this.countryCode == "BNG88"){
      this.navLinks = [
        {
          id: "callList",
          routerLink: "/calling",
          icon: "/eicher/assets/img/calling-list.png",
          name: "Calling List",
        },
        {
          id: "inboundCall",
          routerLink: "/inboundCall",
          icon: "/eicher/assets/img/inbound call.png",
          name: "Inbound Call",
        },
        {
          id: "reporting",
          routerLink: "/reporting",
          icon: "/eicher/assets/img/reporting.png",
          name: "Reporting",
        },
        {
          id: "dashboard",
          routerLink: "/dashboard",
          icon: "/eicher/assets/img/dashboard.png",
          name: "Dashboard",
        }
      ];
    } else if(this.userRoles == "Call Center Agent" && this.countryCode == "BNG88") {
      this.navLinks.push({
        id: "prs-callList",
        routerLink: "/prs-calling",
        icon: "/eicher/assets/img/calling-list.png",
        name: "Calling List",
      });
      this.navLinks.push({
        id: "prs-reporting",
        routerLink: "/prs-reporting",
        icon: "/eicher/assets/img/reporting.png",
        name: "Reporting",
      });
    }

    if (this.userRoles == "Pan India" || this.userRoles == "Channel Service Manager" || this.userRoles == "Area Service Manager" || this.userRoles == "Regional Service Manager") {
      this.navLinks.push({
        id: "prs-reporting",
        routerLink: "/prs-reporting",
        icon: "/eicher/assets/img/reporting.png",
        name: "PRS Reporting",
      });
      this.navLinks.push({
        id: "inboundCall",
        routerLink: "/inboundCall",
        icon: "/eicher/assets/img/inbound call.png",
        name: "Inbound Call",
      });
    }
    if (this.userRoles == "Regional Service Manager"|| this.userRoles == "Channel Service Manager" || this.userRoles == "Service Marketing Manager" ) {
      this.dropdown1.push({
        id: "soft-calling",
        routerLink: "/soft-calling",
        icon: "/eicher/assets/img/calling-list.png",
        name: "Soft Offering",
      });
    }

    if(this.userRoles === "DSPM" && this.countryCode === "IND91") {
    this.dropdown1.push({
      id: "soft-calling",
      routerLink: "/soft-calling",
      icon: "/eicher/assets/img/calling-list.png",
      name: "Soft Offering",
    });

    this.navLinks.push({
      id: "soft-reporting",
      routerLink: "/soft-reporting",
      icon: "/eicher/assets/img/reporting.png",
      name: "Soft Offering Reporting",
    });
  }

    if (this.userRoles == "Dealer Principle") {
      this.navLinks.push({
        id: "prs-reporting",
        routerLink: "/prs-reporting",
        icon: "/eicher/assets/img/reporting.png",
        name: "PRS Reporting",
      });
    }

    if (this.uamAccess == "true" && this.userRoles != "Call Center Agent") {
      if(this.userId == 'ssharma118') {
        this.navLinks.push({
          id: "admin",
          routerLink: "/admin",
          icon: "/eicher/assets/img/reporting.png",
          name: "Fert Master",
        });
      }
      this.navLinks.push({
        id: "uam",
        routerLink: "/uam",
        icon: "/eicher/assets/img/inbound call.png",
        name: "UAM",
      });
    }

    if(this.userInfo.verticalName == "SCV"){
      this.navLinks.push({
        id: "titan-dealer-dashboard",
        routerLink: "/titan-dealer-dashboard",
        icon: "eicher/assets/img/dashboard.png",
        name: "Titan Dealer Dashboard",
      })
    }
    this.notification();
    let source = interval(300000);
    this.subscription = source.subscribe((val) => this.notification());
  }

  /**
   * Name: logout
   * purpose: To Sign out user
   */
  logout() {
    localStorage.clear();
    this.commonService.stopInterval();
    this.commonService.callListResponseData = [];
    this.commonService.prsCallListResponseData = [];
    this.getSigninUpdate(this.userId, 'N', '0');
    this.router.navigate(["/login"]);
  }

  /**
   * Name: profile
   * purpose: To open profile section
   */
  profile() {
    this.router.navigate(["/profile"]);
  }

  saveHeader( navOption: string){
    localStorage.setItem("navOption",navOption);
  }

  openSoft(){
   this.router.navigate(["/soft-calling"]);
  }

  notification() {
    this.message = [];
    this.count = 0;
    this.spinner = true;
    this.commonService.fetchNotification(this.userId).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
          this.notificationList = res["responseData"];
          this.notificationList.forEach((element) => {
            this.message.push(element.message);
            if (element.status == "N") {
              this.count++;
            }
          });
          // if(this.message.length){
          //   this.trigger.openMenu();
          // }
        } else {
          this.spinner = false;
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Schedular Error");
      }
    );
  }

  updateNotification(event?): any {
    event.stopPropagation();
    event.preventDefault();

    this.spinner = true;
    this.commonService.updateNotification(this.userId).subscribe(
      (res) => {
        if (res["responseCode"] == 0) {
          this.spinner = false;
          this.showNotifications = this.showNotifications ? false : true;
          this.notification();
        } else {
          this.spinner = false;
        }
      },
      (err) => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      }
    );
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  displayMenu() {
    this.showNotifications = this.showNotifications ? false : true;
    // alert(this.showNotifications);
  }
  changeColor(): string {
    if (this.count != 0) {
      return "red";
    }
  }

  getSigninUpdate(user: string, flag: string, count: string): void {
    this.commonService.getSigninUpdate(user, flag, count).subscribe(res => {
      if (res['responseCode'] == 0) {
        //console.log(res['responseData'].message);
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, error => {
      this.spinner = false;
      this.toastr.error(error, "Error");
    });
  }

  /**
  * Name: getOperationalDashboardReport
  * purpose: To export Operational Dashboard Report as excel
  */
  getOperationalDashboardReport(): void {
    this.spinner = true;
    let fileName = "SRM_Data Status Report_From_";
    this.commonService.getOperationalDashboardReport(this.userId)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;

      });
  }
}